import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import {  plybtn, shop } from "../../constant";
import "../../assets/css/BuyCar.css";
import ProductCard from "../../components/Card/ProductCard";
import ShowCaseCard from "../../components/ShowCase/ShowCaseCard";
import FindYourCar from "../../components/FindYourCar/FindYourCar";
import Slider from "react-slick/lib/slider";
import LogoSlider from "../../components/Slider/LogoSlider";
import MuiFeatures from "../../components/Accordian/MuiFeatures";
import { useSelector } from "react-redux";
import { GetFilterCar } from "../../network/Network";
import { toast } from "react-toastify";
import { SpinnerCircular } from "spinners-react";
import ReactPaginate from "react-paginate";
import { useLocation } from "react-router-dom";

function CarProduct() {
  const CarConditionRedux = useSelector(
    (state) => state.AuthReducer.carConditionData
  );
  const CarMakeModelRedux = useSelector(
    (state) => state.AuthReducer.carMakeModelData
  );
  const CarOptionDataRedux = useSelector(
    (state) => state.AuthReducer.carOptionData
  );
  const CarCategoryDataRedux = useSelector(
    (state) => state.AuthReducer.carCategoryData
  );
  const CarColorDataRedux = useSelector(
    (state) => state.AuthReducer.carColorData
  );
  const ShowCaseListDataRedux = useSelector(
    (state) => state.AuthReducer.showCaseListData
  );

  const location = useLocation();
  const ParamData = location?.state?.data;
  const ParamData2 = location?.state?.carStyle;
  const brandItem = location?.state?.brand;
  const car_category_id = location?.state?.car_category_id;
  // console.log("pp", ParamData);
  // console.log("pp", ParamData2);
  // console.log("brandItem", brandItem);

  const [carConditionId, setCarConditionId] = useState("");
  const [carMakerId, setCarMakerId] = useState(
    ParamData?.carMaker ? ParamData?.carMaker : null
  );
  const [carModel, setCarModel] = useState(
    ParamData?.carModel ? ParamData?.carModel : null
  );
  const [selectMakerModel, setSelectMakerModel] = useState([]);
  const [carTransmission, setCarTransmission] = useState("");
  const [carDriveType, setCarDriveType] = useState("");
  const [carFuelType, setCarFuelType] = useState("");
  const [carStyle, setCarStyle] = useState(
    ParamData2?.id ? ParamData2?.id : null
  );
  const [minYear, setMinYear] = useState("");
  const [maxYear, setMaxYear] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [mileage, setMileage] = useState("");
  const [color, setColor] = useState("");
  const [loading, setLoading] = useState(false);
  const [spinLoad, setSpinLoad] = useState(false);
  const [vehicleData, setVehicleData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState();
  const [modelTitle, setModelTitle] = useState("");
  const [mainbrand, setMainbrand] = useState();
  const [innerbrand, setInnerbrand] = useState();
  const [model, setModel] = useState(null);

  const handlePageClick = async (data) => {
    // console.log(data.selected);
    setCurrentPage(data?.selected + 1);
  };

  const PostCarSearchHandler = (e = null, brand = null) => {
    if (e) {
      e.preventDefault();
    }
    setCarStyle(ParamData2?.id);
    setSpinLoad(true);
    setLoading(true);
    let colorCode = color.replace("#", "");
    let data = {
      car_category_id: car_category_id ? car_category_id : carStyle,
      make_id: brand?.id? brand?.id : carMakerId,
      model_id: carModel,
      condition_id: carConditionId,
      drive_type_id: carDriveType,
      transmission_id: carTransmission,
      color_code: colorCode,
      fuel_type_id: carFuelType,
      min_year: minYear,
      max_year: maxYear,
      min_price: minPrice,
      max_price: maxPrice,
      mileage: mileage,
    };
    // console.log("data", data);
    GetFilterCar(currentPage, data)
      .then((res) => {
        setLoading(false);
        setSpinLoad(false);
        // console.log("res", res?.data?.response?.data?.data);
        setVehicleData([...res?.data?.response?.data?.data]);
        if (brand) {
          setModelTitle(brand?.title);
          setInnerbrand(brand);
          setModel(brand);
        } else {
          setModelTitle(res?.data?.response?.data?.data[0]?.car_category?.name);
          setModel(res?.data?.response?.data?.data[0]?.car_category);
        }
        const total = res?.data?.response?.data?.total;
        const limit = res?.data?.response?.data?.per_page;
        setPageCount(Math.ceil(total / limit));
      })
      .catch((err) => {
        setLoading(false);
        setSpinLoad(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (brandItem) {
      setCarStyle((preVal) => car_category_id);
      setCarMakerId((preVal) => brandItem?.id);
      setSelectMakerModel((preVal) => {
        return (
          CarMakeModelRedux.find((val) => val?.id == brandItem?.id).car_model ||
          []
        );
      });
    }
    PostCarSearchHandler(null, brandItem ? brandItem : null);
  }, [currentPage, ParamData, ParamData2, brandItem]);

  // console.log("ParamData2", ParamData2);

  // console.log("make",carMakerId)
  // console.log("model",carModel)
  
  return (
    <>
      <Header />
      {/* <!-- Banner Start Here --> */}
      <section className="Slidebanner">
        <div className="banner">
          <div className="slides">
            <div className="img-box">
              <figure>
                {innerbrand?.banner_image_url ? (
                  <img src={innerbrand?.banner_image_url} alt="innerbrand" />
                ) : (
                  <>
                    {ParamData2?.banner_image_url ? (
                      <img
                        src={ParamData2?.banner_image_url}
                        alt="ParamData2"
                      />
                    ) : (
                      <img src={shop} alt="buycarbanner" />
                    )}
                  </>
                )}
              </figure>
            </div>
            <div className="ply-btn">
              <figure>
                <a href="#">
                  <img src={plybtn} alt="123" />
                </a>
              </figure>
            </div>
            <div className="title">
              <h2>
                MusCLES
                <br /> Showcase
              </h2>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Banner Start Here --> */}

      {/* <!-- Car Listing Section --> */}
      <section className="carlist py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-12">
              <div className="new-searchform mb-5" style={{ height: "auto" }}>
                <h3 className="text-white">Show results by:</h3>

                {/* <!-- tab content start here --> */}

                <div className="conditionDv">
                  <div className="title">
                    <h4>Make</h4>
                  </div>
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={(e) => {
                        setCarMakerId(e.target.value);
                        setSelectMakerModel(
                          CarMakeModelRedux.find(
                            (val) => val?.id == e.target.value
                          ).car_model || []
                        );
                      }}
                    >
                      <option selected>Car Make</option>
                      {CarMakeModelRedux?.map((item, index) => {
                        return (
                          <option value={item?.id} key={index}>
                            {item?.title}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="conditionDv">
                  <div className="title">
                    <h4>Model</h4>
                  </div>
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={(e) => {
                        setCarModel(e.target.value);
                      }}
                    >
                      <option selected>Car Model</option>
                      {selectMakerModel?.map((item, index) => {
                        return (
                          <option value={item?.id} key={index}>
                            {item?.title}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="conditionDv">
                  <div className="title">
                    <h4>Condition</h4>
                  </div>
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={(e) => {
                        setCarConditionId(e.target.value);
                      }}
                    >
                      <option selected>Car Condition</option>
                      {CarConditionRedux?.map((item, index) => {
                        return (
                          <option value={item?.id} key={index}>
                            {item?.title}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="conditionDv">
                  <div className="title">
                    <h4>Transmission</h4>
                  </div>
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={(e) => {
                        setCarTransmission(e.target.value);
                      }}
                    >
                      <option selected>Car Transmission</option>
                      {CarOptionDataRedux?.map((item, index) => {
                        return (
                          <>
                            {item?.name === "Transmission" ? (
                              <>
                                {item?.options?.map((item, index) => {
                                  return (
                                    <option value={item?.id} key={index}>
                                      {item?.name}
                                    </option>
                                  );
                                })}
                              </>
                            ) : null}
                          </>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="conditionDv">
                  <div className="title">
                    <h4>Car Category</h4>
                  </div>
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={(e) => {
                        setCarStyle(e.target.value);
                      }}
                    >
                      <option selected>Car Category</option>
                      {CarCategoryDataRedux?.map((item, index) => {
                        return (
                          <option value={item?.id} key={index}>
                            {item?.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="conditionDv">
                  <div className="title">
                    <h4>Drive Type</h4>
                  </div>
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={(e) => {
                        setCarDriveType(e.target.value);
                      }}
                    >
                      <option selected>Select Drive Type</option>
                      {CarOptionDataRedux?.map((item, index) => {
                        return (
                          <>
                            {item?.name === "Drive Type" ? (
                              <>
                                {item?.options?.map((item, index) => {
                                  return (
                                    <option value={item?.id} key={index}>
                                      {item?.name}
                                    </option>
                                  );
                                })}
                              </>
                            ) : null}
                          </>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="conditionDv">
                  <div className="title">
                    <h4>Fuel Type</h4>
                  </div>
                  <div className="form-group">
                    <select
                      className="form-control"
                      onChange={(e) => {
                        setCarFuelType(e.target.value);
                      }}
                    >
                      <option selected>Select Fuel Type</option>
                      {CarOptionDataRedux?.map((item, index) => {
                        return (
                          <>
                            {item?.name === "Fuel Type" ? (
                              <>
                                {item?.options?.map((item, index) => {
                                  return (
                                    <option value={item?.id} key={index}>
                                      {item?.name}
                                    </option>
                                  );
                                })}
                              </>
                            ) : null}
                          </>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="yearsDv mt-2">
                  <div className="title">
                    <h4 className="mb-2 pb-0">Year</h4>
                  </div>
                  <div className="input-group">
                    <div className="form-group">
                      <label for="minyear">Minimum Year</label>
                      <input
                        type="number"
                        className="form-control mr-1"
                        id="distance"
                        placeholder="Min Year"
                        maxlength="4"
                        pattern="\d{4}"
                        value={minYear}
                        onChange={(e) => setMinYear(e.target.value)}
                      />
                    </div>
                    <div className="spacer"></div>
                    <div className="form-group">
                      <label for="maxyear">Maximum Year</label>
                      <input
                        type="number"
                        className="form-control mr-1"
                        id="distance"
                        placeholder="Max Year"
                        maxlength="4"
                        pattern="\d{4}"
                        value={maxYear}
                        onChange={(e) => setMaxYear(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="priceDv mt-2">
                  <div className="title">
                    <h4 className="mb-2 pb-0">Price</h4>
                  </div>
                  <div className="input-group">
                    <div className="form-group">
                      <label for="minyear">Min Price</label>
                      <input
                        type="number"
                        placeholder="Any"
                        className="form-control"
                        id="minyear"
                        value={minPrice}
                        onChange={(e) => setMinPrice(e.target.value)}
                      />
                    </div>
                    <div className="spacer"></div>
                    <div className="form-group">
                      <label for="maxyear">Max Price</label>
                      <input
                        type="number"
                        placeholder="Any"
                        className="form-control"
                        id="maxyear"
                        value={maxPrice}
                        onChange={(e) => setMaxPrice(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="mileageDv">
                  <div className="title">
                    <h4>Mileage</h4>
                  </div>
                  <div className="form-group">
                    <input
                      type="number"
                      placeholder="Mileage"
                      className="form-control"
                      id="maxyear"
                      value={mileage}
                      onChange={(e) => setMileage(e.target.value)}
                    />
                  </div>
                </div>

                <div className="exteriro_color">
                  <div className="title pt-2">
                    <h4>Colors</h4>
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Color"
                      className="form-control"
                      id="maxyear"
                      value={color}
                      onChange={(e) => setColor(e.target.value)}
                    />
                  </div>
                </div>

                <div className="button-group">
                  <button
                    className="btn"
                    onClick={(e) => PostCarSearchHandler(e, true)}
                  >
                    Submit
                  </button>
                </div>
                {/* <!-- tab content end here --> */}
              </div>
              {/* <!-- New Search form end here --> */}
            </div>
            <div className="col-lg-9 col-md-12">
              {/* <!-- find your dream car today --> */}
              <FindYourCar
                CarMakeModelRedux={CarMakeModelRedux}
                selectMakerModel={selectMakerModel}
                setSelectMakerModel={setSelectMakerModel}
                carMakerId={carMakerId}
                setCarMakerId={setCarMakerId}
                carModel={carModel}
                setCarModel={setCarModel}
                PostCarSearchHandler={PostCarSearchHandler}
                page={"AllCars"}
                ParamData2={ParamData2}
              />
              {/* <!-- find your dream car today --> */}
              {/* <!-- Show Case Start Here --> */}
              <section className="showcase carProduct">
                <div className="container">
                  <div className="head">
                    <div>
                      <h2
                        className={`${
                          ParamData2?.name === "Classics & Customs"
                            ? "carProduct-name classic"
                            : ParamData2?.name === "LUXURY & PERFORMANCE"
                            ? "carProduct-name luxury"
                            : ParamData2?.name === "EURO EXOTIC"
                            ? "carProduct-name euro"
                            : ParamData2?.name === "JDM TUNER"
                            ? "carProduct-name jdm"
                            : ParamData2?.name === "SUV & JEEP"
                            ? "carProduct-name suv"
                            : ParamData2?.name === "USA MUSCLE"
                            ? "carProduct-name usa"
                            : "carProduct-name"
                        }`}
                      >
                        {ParamData2 && ParamData2?.name ? (
                          <>{ParamData2?.name}</>
                        ) : (
                          <>
                            {ParamData?.name ? (
                              <>{ParamData?.name}</>
                            ) : (
                              <>
                                {modelTitle ? (
                                  modelTitle
                                ) : (
                                  <>
                                    {model?.car_category?.name ? (
                                      model?.car_category?.name
                                    ) : (
                                      <>
                                        {model?.car_make?.title
                                          ? model?.car_make?.title
                                          : ""}
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            )}
                          </>
                        )}
                       
                      </h2>
                    </div>
                    <h2 className="title">Showcase Listings</h2>
                  </div>
                  <div className="row align-items-start">
                    <div className="col-md-12">
                      <div className="row">
                        {ShowCaseListDataRedux?.map((item, index) => {
                          return (
                            <>
                              {index < 3 ? (
                                <div className="col-md-4" key={index}>
                                  <ShowCaseCard item={item} key={index} />
                                </div>
                              ) : null}
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              {/* <!-- Show Case End Here --> */}
              <div
                className="tab-pane fade show active"
                id="CARS"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                {spinLoad ? (
                  <div className="loader-container">
                    <SpinnerCircular size="80px" color="#d60012" />
                  </div>
                ) : (
                  <>
                    {vehicleData.length > 0 ? (
                      <>
                        {vehicleData?.map((item, index) => {
                          return <ProductCard item={item} index={index} />;
                        })}
                      </>
                    ) : (
                      <p>No Record Found..</p>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="row paggination">
            <div className="col-sm-12 text-right">
              <div className="pagination-container mt-5">
                <ReactPaginate
                  previousLabel="<<"
                  nextLabel=">>"
                  breakLabel={"..."}
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Car Listing Section --> */}
      <Footer />
    </>
  );
}

export default CarProduct;
